import { lastJackpotWinner } from "../../js/api/jackpot.js";
import { userData } from "../../js/api/profile.js";
import IframeModal from "../components/IframeModal.js";
import { getCurrentBalance, updatecasinocurrency } from "../../js/api/balance.js";
import { _t } from "../../services/TranslationService.js";
import { getSlotGames } from "../../js/api/slots.js";

let Slots = {
  render: async () => {
    const casino_enabled = localStorage.getItem('casino_enabled') === '1';
    if (!casino_enabled) {
      window.location.href = '#/';
      return '';
    }

    const lastJackpotWinnerLabel = await lastJackpotWinner();
    let view = /*html*/ `
    <div class="modalHelperHolder">
    <div class="modalHelperPosition">
        <span>${_t('Zgjedh monedhen per casino')}</span>
        <select id="coinSelectorSelect">
        </select>
        <a class="submitBtn modalHandler" id="submitCoinSelected">${_t('Vazhdo')}</a>
    </div>
  </div>
          <div class="machineBoxesHolder" style="overflow-x: auto;">
              <div class="machineBox firstItem" game="BookofRaMagic">
                  <div class="machineItem">
                      <img src="img/book-of-ra-deluxe_tile.png" alt="" />
                      <img src="img/book-of-ra-deluxe_screenshot.jpg" alt="" />
                  </div>
                  <span>Book of Ra Magic</span>
                  <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"><g><path d="m376 31c-54.544 0-95.017 33.497-120 81.015-24.981-47.515-65.454-81.015-120-81.015-78.609 0-136 66.015-136 146.515 0 106.457 101.572 173.291 246.122 299.773 5.657 4.949 14.099 4.948 19.756 0 144.417-126.366 246.122-193.303 246.122-299.773 0-80.513-57.4-146.515-136-146.515zm-120 415.101c-133.122-115.635-226-179.872-226-268.586 0-66.424 45.57-116.515 106-116.515 58.252 0 94.351 53.947 105.542 93.996 4.036 14.61 24.83 14.675 28.916 0 11.043-39.518 46.723-93.996 105.542-93.996 60.43 0 106 50.091 106 116.515 0 88.765-93.03 153.083-226 268.586z"/></g></svg>
              </div>
              <div class="machineBox" game="FourLuckyClover">
                  <div class="machineItem">
                      <img src="img/FourLuckyClover_tile.png" alt="" />
                      <img src="img/FourLuckyClover_screenshot.jpg" alt="" />
                  </div>
                  <span>Four Lucky Clover</span>
                  <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"><g><path d="m376 31c-54.544 0-95.017 33.497-120 81.015-24.981-47.515-65.454-81.015-120-81.015-78.609 0-136 66.015-136 146.515 0 106.457 101.572 173.291 246.122 299.773 5.657 4.949 14.099 4.948 19.756 0 144.417-126.366 246.122-193.303 246.122-299.773 0-80.513-57.4-146.515-136-146.515zm-120 415.101c-133.122-115.635-226-179.872-226-268.586 0-66.424 45.57-116.515 106-116.515 58.252 0 94.351 53.947 105.542 93.996 4.036 14.61 24.83 14.675 28.916 0 11.043-39.518 46.723-93.996 105.542-93.996 60.43 0 106 50.091 106 116.515 0 88.765-93.03 153.083-226 268.586z"/></g></svg>
              </div>
              <div class="machineBox" game="40SuperHot">
                  <div class="machineItem">
                      <img src="img/redhotfruits_tile.png" alt="" />
                      <img src="img/redhotfruits_screenshot.jpg" alt="" />
                  </div>
                  <span>40 Super Hot</span>
                  <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"><g><path d="m376 31c-54.544 0-95.017 33.497-120 81.015-24.981-47.515-65.454-81.015-120-81.015-78.609 0-136 66.015-136 146.515 0 106.457 101.572 173.291 246.122 299.773 5.657 4.949 14.099 4.948 19.756 0 144.417-126.366 246.122-193.303 246.122-299.773 0-80.513-57.4-146.515-136-146.515zm-120 415.101c-133.122-115.635-226-179.872-226-268.586 0-66.424 45.57-116.515 106-116.515 58.252 0 94.351 53.947 105.542 93.996 4.036 14.61 24.83 14.675 28.916 0 11.043-39.518 46.723-93.996 105.542-93.996 60.43 0 106 50.091 106 116.515 0 88.765-93.03 153.083-226 268.586z"/></g></svg>
              </div>
              <div class="machineBox" game="SizzlingHotDeluxe">
                  <div class="machineItem">
                      <img src="img/sizzlinghot_tile.png" alt="" />
                      <img src="img/sizzlinghot_screenshot.jpg" alt="" />
                  </div>
                  <span>Sizzling Hot Deluxe</span>
                  <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"><g><path d="m376 31c-54.544 0-95.017 33.497-120 81.015-24.981-47.515-65.454-81.015-120-81.015-78.609 0-136 66.015-136 146.515 0 106.457 101.572 173.291 246.122 299.773 5.657 4.949 14.099 4.948 19.756 0 144.417-126.366 246.122-193.303 246.122-299.773 0-80.513-57.4-146.515-136-146.515zm-120 415.101c-133.122-115.635-226-179.872-226-268.586 0-66.424 45.57-116.515 106-116.515 58.252 0 94.351 53.947 105.542 93.996 4.036 14.61 24.83 14.675 28.916 0 11.043-39.518 46.723-93.996 105.542-93.996 60.43 0 106 50.091 106 116.515 0 88.765-93.03 153.083-226 268.586z"/></g></svg>
              </div>
          </div>

          <div class="fragment jackpots-container has-show-more jack-related jackpots show-more-handle-taphold shown-more-yes">
             <div class="jackpotAnimation jackpotMain">
                <div class="horizontalBar topBorder">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                    <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                    <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                    <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                  </svg>
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                    <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                    <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                    <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                  </svg>
                  <div class="dotsWrapper">
                    <div class="dotsHolder">
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                    </div>
                  </div>
                </div>
                <div class="verticalBar rightBorder">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                    <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                    <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                    <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                  </svg>
                  <div class="dotsWrapper">
                    <div class="dotsHolder">
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                    </div>
                  </div>
                </div>
                <div class="horizontalBar bottomBorder">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                    <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                    <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                    <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                  </svg>
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                    <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                    <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                    <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                  </svg>
                  <div class="dotsWrapper">
                    <div class="dotsHolder">
                      <span class="light active"><i class="lightOn"></i></span>
                      <span class="light active"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light active"><i class="lightOn"></i></span>
                      <span class="light active"><i class="lightOn"></i></span>
                      <span class="light active"><i class="lightOn"></i></span>
                    </div>
                  </div>
                </div>
                <div class="verticalBar leftBorder">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                    <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                    <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                    <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                  </svg>
                  <div class="dotsWrapper">
                    <div class="dotsHolder">
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light"><i class="lightOn"></i></span>
                      <span class="light active"><i class="lightOn"></i></span>
                      <span class="light active"><i class="lightOn"></i></span>
                    </div>
                  </div>
                </div>
                <div class="cornerJackpot topLeftCorner">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                  <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                  	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                  	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                  	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                  <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                  	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                  	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                  	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                  <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                  	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                  	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                  	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                  </svg>
                </div>
                <div class="cornerJackpot bottomLeftCorner">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                  <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                  	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                  	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                  	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                  <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                  	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                  	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                  	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                  <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                  	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                  	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                  	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                  </svg>
                </div>
                <div class="cornerJackpot topRightCorner">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                  <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                  	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                  	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                  	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                  <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                  	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                  	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                  	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                  <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                  	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                  	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                  	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                  </svg>
                </div>
                <div class="cornerJackpot bottomRightCorner">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                  <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                  	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                  	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                  	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                  <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                  	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                  	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                  	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                  <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                  	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                  	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                  	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                  </svg>
                </div>
                <div class="jackpots-cont-wrapper first-row-jackpots">
                    <div class="jackpot JCK jackpotID_3 jackpot_0" data-jackid="3" data-valuta="eur">
                       <div class="jack-inside-lights">
                          <div class="jackpot-pulsing-bg jackpot_pbg_3" style=""></div>
                          <i class="icon icon-crown-1 jackpot-icon"></i>
                          <div class="jack-name">
                             <div class="jackname ">Mega JackPot</div>
                             <span class="jack-value"><span class="numbers">${parseFloat(
                               localStorage.getItem("jackpot_value")
                                 ? parseFloat(
                                     localStorage.getItem("jackpot_value")
                                   ) + 7350.29
                                 : 7503.78
                             ).toFixed(
                               2
                             )}</span><span class="valuta_sign valutaID_eur">€</span></span>
                          </div>
                       </div>
                    </div>
                 </div>
              </div>
             <div class="jackpots-cont-wrapper second-row-jackpots">
                <div class="jackpotAnimation jackpotSecond">

                  <div class="horizontalBar topBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="verticalBar rightBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="horizontalBar bottomBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="verticalBar leftBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="cornerJackpot topLeftCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot bottomLeftCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot topRightCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot bottomRightCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="jackpot JCK jackpotID_2 jackpot_1" data-jackid="2" data-valuta="eur">
                     <div class="jack-inside-lights">
                        <div class="jackpot-pulsing-bg jackpot_pbg_2" style=""></div>
                        <i class="icon icon-weekly-jack icon-jcolor-2 jackpot-icon"></i>
                        <div class="jack-name">
                           <div class="jackname ">Silver JackPot</div>
                           <span class="jack-value"><span class="numbers">${parseFloat(
                             localStorage.getItem("jackpot_value")
                               ? parseFloat(
                                   localStorage.getItem("jackpot_value")
                                 ) + 1369.93
                               : 1291.26
                           ).toFixed(
                             2
                           )}</span><span class="valuta_sign valutaID_eur">€</span></span>
                        </div>
                     </div>
                  </div>
                </div>
                <div class="jackpotAnimation jackpotThird">
                  <div class="horizontalBar topBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="verticalBar rightBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="horizontalBar bottomBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light active"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="verticalBar leftBorder">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="508px" height="7px" viewBox="0 -1 508 7" enable-background="new 0 -1 508 7" xml:space="preserve">
                      <path fill="#6d0800" d="M0,0c0,1.32,0,2.641,0,3.96l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#6d0800" d="M0,2.04C0,3.36,0,4.681,0,6l508-0.944c0-1.005,0-2.01,0-3.016H0z"></path>
                      <path fill="#ad7818" d="M0,5c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                      <path fill="#dbc045" d="M0-1c0,0.333,0,0.667,0,1h508c0-0.333,0-0.667,0-1H0z"></path>
                    </svg>
                    <div class="dotsWrapper">
                      <div class="dotsHolder">
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                        <span class="light"><i class="lightOn"></i></span>
                      </div>
                    </div>
                  </div>
                  <div class="cornerJackpot topLeftCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot bottomLeftCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot topRightCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="cornerJackpot bottomRightCorner">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                    <path fill="#6d0800" d="M547.5,157h-537c-0.663,0-1.299-0.263-1.768-0.732l-7-7C1.263,148.799,1,148.163,1,147.5L0.792,7.075
                    	c0-0.663,0.472-0.874,0.94-1.343l4-4C6.201,1.263,5.837,1,6.5,1h541c0.663,0,1.299,0.263,1.768,0.732l7,7
                    	C556.737,9.201,557,9.837,557,10.5v137c0,0.663-0.263,1.299-0.732,1.768l-7,7C548.799,156.737,548.163,157,547.5,157z M11.536,152
                    	h534.929l5.536-5.536V11.536L546.464,6H9.536L6,9.536v136.929L11.536,152z"></path>
                    <path fill="#ad7818" d="M548.5,155h-536c-0.146,0-0.285-0.064-0.38-0.175l-6-7C6.043,147.735,6,147.619,6,147.5V9.5
                    	c0-0.133,0.053-0.26,0.146-0.354l3-3C9.24,6.053,9.367,6,9.5,6h539c0.146,0,0.285,0.064,0.38,0.175l6,7
                    	c0.078,0.09,0.12,0.206,0.12,0.325v134c0,0.119-0.042,0.235-0.12,0.325l-6,7C548.785,154.936,548.646,155,548.5,155z M12.73,154
                    	h535.54l5.73-6.685V13.685L548.27,7H9.707L7,9.707v137.608L12.73,154z"></path>
                    <path fill="#dbc045" d="M548.5,157H8.5c-0.143,0-0.279-0.061-0.374-0.168l-8-9C0.045,147.741,0,147.623,0,147.5V6.5
                    	c0-0.133,0.053-0.26,0.146-0.354l6-6C6.24,0.053,6.367,0,6.5,0h542c0.143,0,0.279,0.061,0.374,0.168l8,9
                    	C556.955,9.259,557,9.377,557,9.5v139c0,0.133-0.053,0.26-0.146,0.354l-8,8C548.76,156.947,548.633,157,548.5,157z M8.725,156
                    	h539.568l7.707-7.707V9.69L548.275,1H6.707L1,6.707V147.31L8.725,156z"></path>
                    </svg>
                  </div>
                  <div class="jackpot JCK jackpotID_1 jackpot_2" data-jackid="1" data-valuta="eur">
                     <div class="jack-inside-lights">
                        <div class="jackpot-pulsing-bg jackpot_pbg_1" style=""></div>
                        <i class="icon icon-daily-jack2 icon-jcolor-3 jackpot-icon"></i>
                        <div class="jack-name">
                           <div class="jackname ">Daily JackPot</div>
                           <span class="jack-value"><span class="numbers">${parseFloat(
                             localStorage.getItem("jackpot_value")
                               ? parseFloat(
                                   localStorage.getItem("jackpot_value")
                                 ) + 20.17
                               : 291.26
                           ).toFixed(
                             2
                           )}</span><span class="valuta_sign valutaID_eur">€</span></span>
                        </div>
                     </div>
                  </div>
                </div>
             </div>
          </div>
          <div class="jcakpotHolder" style="display:none;">
            <div class="jackpotHeader">
               <div class="jackpotLeftHeader">
                  <span>Mega JackPot</span>
                  <span>${parseFloat(
                    localStorage.getItem("jackpot_value")
                      ? parseFloat(localStorage.getItem("jackpot_value")) +
                          7350.29
                      : 7503.78
                  ).toFixed(2)}&euro;</span>
               </div>
               <div class="jackpotRightHeader">
                  <span>Gold JackPot</span>
                  <span>${parseFloat(
                    localStorage.getItem("jackpot_value")
                      ? parseFloat(localStorage.getItem("jackpot_value")) +
                          3100.96
                      : 3379.94
                  ).toFixed(2)}&euro;</span>
                </div>
            </div>
            <div class="jackpotContent">
                <img src="img/jackpott.gif" alt="">
<!--                <span class="bigTextJackpot">JACKPOT</span>-->
<!--                <span class="smallTextJackpot">LUAJ PËR</span>-->
            </div>
            <div class="jackpotFooter">
            <div class="jackpotLeftFooter">
                  <span>Silver JackPot</span>
                  <span>${parseFloat(
                    localStorage.getItem("jackpot_value")
                      ? parseFloat(localStorage.getItem("jackpot_value")) +
                          1369.93
                      : 1291.26
                  ).toFixed(2)}&euro;</span>
               </div>
               <div class="jackpotRightFooter">
                  <span>Quick JackPot</span>
                  <span>${
                    localStorage.getItem("jackpot_value")
                      ? localStorage.getItem("jackpot_value")
                      : 0
                  }&euro;</span>
                </div>
            </div>
            ${
              lastJackpotWinnerLabel
                ? `
            <div class="jackpotFooter">
         <div class="jackpotMiddleFooter">
         <span>Last jackpot</span>
         <span>${lastJackpotWinnerLabel.name} - ${lastJackpotWinnerLabel.transaction_time}</span>
      </div>
      </div>
            `
                : ""
            }
          </div>
       <div class="slotsCatHolder">
            <div class="slotsCatHelper" id="slotsCatBtn">
            </div>
       </div>
       <div class="slotsMainWrapper">
          <script type="text/javascript" src="//ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js"></script>
          <script type="text/javascript" src="//ajax.googleapis.com/ajax/libs/swfobject/2.2/swfobject.js"></script>
          <script type="text/javascript">

          </script>
          <div id="main">
            <!--Game selector will be displayed here -->
          </div>
          <div id="overlay"></div>
          <iframe id="iframeSlot" src="" ></iframe>
          <div id="game_container">
            <div id="game_flash"></div>
          </div>
       </div>
       `;
    return view;
  },
  after_render: async () => {
    const slot_games = await getSlotGames();
    const userDataBody = await userData(localStorage.getItem("user_id"));
    // if (!$("body").hasClass("bg-black")) {
    //   $("body").removeClass("bg-black");
    // }

    $("body").click(function (e) {
      if (!$(e.target).is(".modalHelperPosition,.modalHelperPosition *")) {
        $(".modalHelperHolder").removeClass("active");
      }
    });

    setCurrentBalanceForSlots();

    jackpotMainAnimation();
    jackpotSecondAnimation();
    jackpotThirdAnimation();

    setInterval(jackpotMainAnimation, $(".jackpotMain .light").length * 75);
    setInterval(jackpotSecondAnimation, $(".jackpotSecond .light").length * 70);
    setInterval(jackpotThirdAnimation, $(".jackpotThird .light").length * 70);

    function jackpotMainAnimation() {
      $(".jackpotMain .light").each(function (i, el) {
        setTimeout(function () {
          $(el).addClass("active");
          setTimeout(function () {
            $(el).removeClass("active");
          }, 155);
        }, i * 70);
      });
    }
    function jackpotSecondAnimation() {
      $(".jackpotSecond .light").each(function (i, el) {
        setTimeout(function () {
          $(el).addClass("active");
          setTimeout(function () {
            $(el).removeClass("active");
          }, 155);
        }, i * 70);
      });
    }
    function jackpotThirdAnimation() {
      $(".jackpotThird .light").each(function (i, el) {
        setTimeout(function () {
          $(el).addClass("active");
          setTimeout(function () {
            $(el).removeClass("active");
          }, 155);
        }, i * 70);
      });
    }

    $("body .machineBoxesHolder").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      dots: false,
      prevArrow: false,
      nextArrow: false,
      centerPadding: "20px",
    });

    var mainIndex = 0;
    let groupContent = "";

    for (let index = 0; index < slot_games.length; index++) {
      let content = "";
      const element = slot_games[index];
      for (let i = 0; i < element.Data.length; i++) {
        const e = element.Data[i].screenName;
        const id = element.Data[i].id ? element.Data[i].id : element.Data[i].name;
        const img = element.Data[i].img;
        // content += `<div class="game" familyid="${element.Type}" game="${e}"><span>${e}</span></div>`;
        // content += `<div class="game animation-element" game="${id}"><img src="./img/games_icons/${id}.jpg" onerror="javascript:this.src='./img/games_icons/duser.jpg'"><span>${e}</span><svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="18" viewBox="0 0 512 512" width="18"><g><path d="m376 31c-54.544 0-95.017 33.497-120 81.015-24.981-47.515-65.454-81.015-120-81.015-78.609 0-136 66.015-136 146.515 0 106.457 101.572 173.291 246.122 299.773 5.657 4.949 14.099 4.948 19.756 0 144.417-126.366 246.122-193.303 246.122-299.773 0-80.513-57.4-146.515-136-146.515zm-120 415.101c-133.122-115.635-226-179.872-226-268.586 0-66.424 45.57-116.515 106-116.515 58.252 0 94.351 53.947 105.542 93.996 4.036 14.61 24.83 14.675 28.916 0 11.043-39.518 46.723-93.996 105.542-93.996 60.43 0 106 50.091 106 116.515 0 88.765-93.03 153.083-226 268.586z"></path></g></svg></div>`;
        content += `<div class="game animation-element" game="${id}"><img src="${img}" onerror="javascript:this.src='./img/games_icons/duser.jpg'"><span>${e}</span><svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="18" viewBox="0 0 512 512" width="18"><g><path d="m376 31c-54.544 0-95.017 33.497-120 81.015-24.981-47.515-65.454-81.015-120-81.015-78.609 0-136 66.015-136 146.515 0 106.457 101.572 173.291 246.122 299.773 5.657 4.949 14.099 4.948 19.756 0 144.417-126.366 246.122-193.303 246.122-299.773 0-80.513-57.4-146.515-136-146.515zm-120 415.101c-133.122-115.635-226-179.872-226-268.586 0-66.424 45.57-116.515 106-116.515 58.252 0 94.351 53.947 105.542 93.996 4.036 14.61 24.83 14.675 28.916 0 11.043-39.518 46.723-93.996 105.542-93.996 60.43 0 106 50.091 106 116.515 0 88.765-93.03 153.083-226 268.586z"></path></g></svg></div>`;
        // content += `<div class="game" game="${id}"><img src="/bettting_app/user/src/img/games_icons/${id}.jpg" /><span>${e}</span></div>`;
      }

      if (mainIndex == 0) {
        console.log(element, 'asdasd')
        $("body #slotsCatBtn").append(
          `<div class="groupFamilyBtn active" data-btn-target="${element.Type}"><span class="">${element.Type}</span></div>`
        );
        groupContent += `<div class="groupGame active ${element.Type}">${content}</div>`;
      } else {
        if (element.Type !== "GAMINATOR-NOVOMATIC") {
          $("body #slotsCatBtn").append(
            `<div class="groupFamilyBtn" data-btn-target="${element.Type}"><span class="">${element.Type}</span></div>`
          );
          groupContent += `<div class="groupGame ${element.Type}">${content}</div>`;
        }
      }

      mainIndex++;
    }

    let catLengthWidth = 0;
    $(".groupFamilyBtn ").each(function (e) {
      catLengthWidth += $(this).outerWidth();
    });
    $("body .slotsCatHelper").css({
      width: catLengthWidth + 3 + "px",
    });

    $("#main").html(groupContent);

    $("body").on("click", ".groupFamilyBtn", function (e) {
      let eventTarget = $(e.currentTarget).attr("data-btn-target");
      console.log(eventTarget);
      $("body .groupFamilyBtn").removeClass("active");
      $("body .groupGame").removeClass("active");
      $(e.currentTarget).addClass("active");
      $("body ." + eventTarget + "").addClass("active");
    });

    $("body").on("click", "#submitCoinSelected", async function (e) {
      const res = await updatecasinocurrency($("#coinSelectorSelect").val());
      alert(_t("Monedha u vendos, vazhdoni te luani!!"));
      callSliderEvent();
    });

    $("body").on("click", ".machineBox", function (e) {
      if (
        !localStorage.getItem("access_token") ||
        localStorage.getItem("access_token") == ""
      ) {
        alert("Login!");
        return;
      }
      if (userDataBody.casinoEnabled != "1") {
        alert(_t("Nuk keni qasje ne lojet e Casino!"));
        return;
      }
      const gameName = $(e.currentTarget).attr("game");
      const gameLink = `${location.origin}/casino/index?game=${gameName}&u=${localStorage.getItem(
        "access_token"
      )}`;
      // IframeModal.loadIframe(gameLink);
      // IframeModal.show(gameName);
      // window.location.href = gameLink;
      IframeModal.openInNewTab(gameLink);
      // if (location.host == 'eccoplay365.com') {
      //   IframeModal.loadIframe(gameLink);
      //   IframeModal.show(gameName);
      // } else {
      //   window.location.href = gameLink;
      // }
    });

    $("body .game").unbind("click");
    $("body .game").on("click", async function (e) {
      if (
        !localStorage.getItem("access_token") ||
        localStorage.getItem("access_token") == ""
      ) {
        alert("Login!");
        return;
      }

      if (userDataBody.casinoEnabled != "1") {
        alert(_t("Nuk keni qasje ne lojet e Casino!"));
        return;
      }
      $(e.currentTarget).addClass("clicked");
      const gameName = $(e.currentTarget).attr("game");
      // setTimeout(function () {
        const gameLink = `${location.origin}/casino/index?game=${gameName}&u=${localStorage.getItem(
          "access_token"
        )}`;
        // console.log(gameLink);
        // window.location.href = gameLink;

        IframeModal.openInNewTab(gameLink);
        // if (location.host == 'eccoplay365.com') {
        //   IframeModal.loadIframe(gameLink);
        //   IframeModal.show(gameName);
        // } else {
        //   window.location.href = gameLink;
        // }
        $(e.currentTarget).removeClass("clicked");
      // }, 2000);

      // IframeModal.loadIframe(gameLink);
      // IframeModal.show(gameName);

      // var win = window.open(
      //   ``,
      //   "_blank"
      // );
      // if (win) {
      //   //Browser has allowed it to be opened
      //   win.focus();
      // } else {
      //   //Browser has blocked it
      //   alert("Please allow popups for this website");
      // }
    });
  },
};

async function setCurrentBalanceForSlots() {
  var currentBalanceResult = await getCurrentBalance();

  if (currentBalanceResult.casino_currency) return;

  var coins = [];

  if (currentBalanceResult && currentBalanceResult.total_coins) {
    var allCoins = currentBalanceResult.total_coins.split("|");

    if (currentBalanceResult.total_coins.includes("|")) {
      var allCoins = currentBalanceResult.total_coins.split("|");

      for (let index = 0; index < allCoins.length; index++) {
        const coin = allCoins[index];
        const currency = coin.split(";")[0].split(".")[1];
        coins.push({
          currency,
          id: coin.split(";")[0].split(".")[0],
        });

        const value = coin.split(";")[1];
      }
    } else {
      if (currentBalanceResult.currency) {
        coins.push({
          currency: currentBalanceResult.currency,
          id: currentBalanceResult.currency_id,
        });
      } else {
        const currency = currentBalanceResult.total_coins
          .split(";")[0]
          .split(".")[1];
        coins.push({
          currency,
          id: currentBalanceResult.total_coins.split(";")[0].split(".")[0],
        });
      }
    }
  }

  renderCoins(coins);
  callSliderEvent();
}

async function renderCoins(coins) {
  coins.forEach((element) => {
    $("#coinSelectorSelect").append(`<option value="${element.id}"> 
       ${element.currency}   
 </option>`);
  });
}

function callSliderEvent() {
  if ($("body .modalHelperHolder").hasClass("active")) {
    $("body .modalHelperHolder").removeClass("active");
  } else {
    $("body .modalHelperHolder").addClass("active");
  }
}

export default Slots;
